<template>
    <div class="checkout relative">
    <HeaderDashboard />
        <main class="checkout-component bg-gray-50 pt-16 md:pt-36 pb-10">
            <div class="mx-auto flex flex-col md:flex-row max-w-7xl container">
                <DashboardSidebarMenu isPage="suscripción"/>
                <div class="main-content w-full md:w-4/5 flex flex-col">
                    <section class="mb-5"> 
                        <div class="max-w-6xl mx-auto px-4">
                            <div class="box px-5 sm:px-10 pt-10 pb-4 w-full">
                                <div class="mb-5">
                                    <h1 class="m-0 text-xl md:text-xl text-green-500 font-bold" :class="{'disabled' : companionsDataType.type != 'SUCCESS'}">{{dashboardTranslate[language].subscription.modify.companions.title}}</h1>
                                    <p :class="{'disabled' : companionsDataType.type != 'SUCCESS'}">{{dashboardTranslate[language].subscription.modify.companions.subtitle}}</p>
                                </div>
                                
                                <!-- Escenario de membresía de plan mensual -->
                                <Notification
                                type="info"
                                :title="notificationTranslate[language].infoChargePayment.title"
                                :content="notificationTranslate[language].infoChargePayment.subtitle"
                                class="hidden"
                                />

                                <!-- Escenario de membresía de plan anual -->
                                <Notification
                                type="info"
                                 :title="notificationTranslate[language].infoChargePaymentMethod.title"
                                :content="notificationTranslate[language].infoChargePaymentMethod.subtitle"
                                class="hidden"
                                />

                                <Notification
                                    type="success"
                                    :title="notificationTranslate[language].companions.addCompanions.title"
                                    :content="notificationTranslate[language].companions.addCompanions.subtitle"
                                    v-if="isSuccess"
                                /> 
                                 <Notification
                                    type="error"
                                    :title="notificationTranslate[language].errorChangeSubscription.title"
                                    :content="notificationTranslate[language].errorChangeSubscription.subtitle"
                                    class="hidden"
                                /> 
                                <Notification
                                    type="error"
                                    :title="'Error'"
                                    :content="errorMessage"
                                    v-if="isError"
                                />
                            
                                <Notification
                                    type="warning"
                                    title="Warning"
                                    v-if="companionsDataType.type == 'WARNING'"
                                    :content="notificationTranslate[language].companions[companionsDataType.code].title"
                                /> 
                                <div v-if="loading">
                                    <img class="mx-auto"  src="@/assets/img/app-loader.gif" width="150" alt="">
                                </div>
                                <div v-else>
                                    <div class="border-b pb-5 " :class="{'disabled' : type == 'single', 'disabled' : companionsDataType.type != 'SUCCESS'}" v-if="addOns || companionsData">
                                        <h4 class="mb-1">{{checkoutTranslate[language].user.membershipCompanions}}</h4>
                                            <p class="text-gray-800 mb-5 text-sm" v-if="companionsDataType.type != 'WARNING'">{{checkoutTranslate[language].user.companionsEdit( addOns.currentQuantity + addOnCount, addOns.defaultQuantity  - addOns.currentQuantity - addOnCount  )}}</p>
                                              <p class="text-gray-800 mb-5 text-sm" v-else>
                                                  <span v-if="companionsDataType.type == 'WARNING' &&  companionsDataType.code == 'CompanionLimitReached'">
                                                    {{notificationTranslate[language].companions[companionsDataType.code].title}}
                                                  </span>
                                            </p>

                                        <div class="w-4/5 xs:w-full flex flex-col md:flex-row justify-start items-start ">
                                            <div class="p-0 mb-5 md:mb-0 md:pr-10 lg:w-3/5 sm:w-full xs:w-full">
                                                <h5 class="block">{{checkoutTranslate[language].user.numberCompanions}}</h5>
                                                <div class="flex flex-row w-full justify-between mt-2 mb-2" v-if="companionsData">

                                                    <button @click="onChange('sub')" class="rounded-full bg-blue-100 text-white w-12 h-12 flex justify-center items-center content-center" 
                                                    :class="{'disabled' : addOnCount == 0 }"
                                                    :disabled='type == "single" &&  addOnCount == 0 '>
                                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clip-rule="evenodd" />
                                                        </svg>
                                                    </button>
                                                    <div class="relative flex content-center items-center w-12 py-2 text-2xl text-green-500 font-bold justify-center">
                                                        {{ addOnCount }}
                                                    </div>
                                                    <button @click="onChange('add')" class="rounded-full bg-blue-100 text-white w-12 h-12 flex justify-center items-center content-center" 
                                                    :class="{'disabled' : addOns.defaultQuantity - addOns.currentQuantity  == addOnCount}" :disabled='type == "single"'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="flex flex-row items-start justify-between md:items-end w-full">
                                                <div class="p-0 md:pr-10  flex flex-col items-end md:items-end w-auto md:w-full xs:items-center xs:w-1/2">
                                                    <h5>{{checkoutTranslate[language].user.membership}}</h5>
                                                    <div class="flex flex-row content-start">
                                                        <h3 class="text-3xl md:text-2xl font-bold text-green-500"> 
                                                            <span>
                                                                {{ addOns.netAmount }}
                                                            </span>
                                                            </h3>
                                                        <span class="text-sm md:text-xs text-green-500 mt-1 mx-1">$</span>
                                                    </div>
                                                    <h5 class="-mt-1">{{currency}} /
                                                        <span v-if="subscription.subscription.currentAmount.paymentTerm == 'Annual' ">
                                                            {{checkoutTranslate[language].payment.yearly}}
                                                        </span>
                                                        <span v-else>
                                                            {{checkoutTranslate[language].payment.month}}
                                                        </span>
                                                    </h5>
                                                </div>
                                                <div class="p-0 md:pr-10 flex flex-col items-end md:items-end w-1/2 md:w-full xs:items-center xs:w-1/2">
                                                    <h5>{{checkoutTranslate[language].user.extraCompanion}}</h5>
                                                    <div class="flex flex-row content-start">
                                                        <h3 class="text-3xl md:text-2xl font-bold text-green-500">
                                                            {{ parseFloat(addOnPrice).toFixed(0) }}
                                                        </h3>
                                                        <span class="text-sm md:text-xs text-green-500 mt-1 mx-1">$</span>
                                                    </div>
                                                    <h5 class="-mt-1">{{currency}} / 
                                                        <span v-if="subscription.subscription.currentAmount.paymentTerm == 'Annual' ">
                                                            {{checkoutTranslate[language].payment.yearly}}
                                                        </span>
                                                        <span v-else>
                                                            {{checkoutTranslate[language].payment.month}}
                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex content-start items-center  sm:flex-row xs:flex-col flex-row align-middle ">
                                        <div class="text-xs sm:w-full xs:w-full flex align-middle items-center xs:pt-5">
                                            {{ checkoutTranslate[language].user.increaseCompanionsSolo(  currency) }}
                                        </div>
                                        <div class="w-6/12 flex justify-end content-center items-center xs:w-full sm:w-full xs:mt-5 sm:mt-5 md:mt-0 py-5" v-if="companionsData">
                                            <a @click.prevent="onBack('DashboardSubscription')" href="#" class="py-3 px-5 border-b-4 font-bold text-green-500 md:mr-10 text-center hover:border-green-200 hover:text-green-200 xs:mx-2">{{checkoutTranslate[language].button.cancel}}</a>
                                            <button class="py-5  border-b-5 font-bold  bg-blue-100 hover:bg-blue-200 text-white rounded-xl lg:px-8 xs:w-1/2 xs:mx-2" 
                                            :class="{'disabled' : addOnCount + 1 == companionsData.currentQuantity, 'disabled' : companionsDataType.type != 'SUCCESS'}"

                                            :disabled="companionsDataType.type != 'SUCCESS'"
                                            @click="onChangePlan"> {{ checkoutTranslate[language].button.change }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                 <div class="text-center p-10">
                    <div>{{dashboardTranslate[language].information.text }} </div>
                    <div><a :href="`mailto:${dashboardTranslate[language].information.email}`" class="text-green-400 font-semibold">{{dashboardTranslate[language].information.email }} </a></div>
                </div>
                    </section>
                </div>
            </div>
        </main>
    <FooterCheckout />
    </div>
</template>

<script>
import HeaderDashboard from "@/components/header/Header.vue"
import FooterCheckout from "@/components/Footer.vue"
import DashboardSidebarMenu from "@/components/dashboard/SidebarMenu.vue"
import Notification from "@/components/notifications/Notification.vue"
import { useStore } from "vuex"
import { computed, ref } from "@vue/reactivity"
import { checkoutTranslate } from '@/translations/Checkout.js'
import { dashboardTranslate } from '@/translations/Dashboard.js'
import { notificationTranslate } from '@/translations/Notifications.js'
import { dataLayerAddCompanions, dataLayerViewChangeNotification } from  '@/pixels/datalayer.js'

import { onMounted } from "@vue/runtime-core"
import { useRouter } from "vue-router"

export default({
    name: 'ModifyCompanions',
    components: {
        HeaderDashboard,
        FooterCheckout,
        DashboardSidebarMenu,
        Notification,
    },

    setup(){

        const router = useRouter()
        const store = useStore()
        const addOnCount = ref(0)
        const addOnPrice = ref(0)
        const total = ref({ totalAmount:0, totalTermAmount: 0 })

        const errorMessage = computed( () => {
            return store.state.Checkout.error.companions
        })
        const isError = computed( ()=> {
             return store.state.Checkout.isError.companions
        })
        const selected = computed( () => {
            return store.getters.getSelectedPlan
        })
        const language = computed( ()=> {
            return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
        })
        const subscription = computed(() => {
            return store.state.Checkout.data.userSubscription.data
        })
            const currency = computed(() => {
            return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
        })
        const plans = computed( () => {
            return store.state.Plans.data.plans 
        })
        const success = computed(() => {
                return store.state.Checkout.success.companions
            })
        const isSuccess = computed(() => {
            return store.state.Checkout.isSuccess.companions
        })
        const loading = computed(() => {
            return store.state.Plans.loading || store.state.Checkout.loading.companions 
        })

        const companionsData =  computed(() => {
            return store.state.Checkout.data.userCompanions ? store.state.Checkout.data.userCompanions : { currentQuantity : 0 }
        })
          const companionsDataType = computed( () => {
            return store.state.Checkout.status.userCompanions
        })


        const onBack = ( routeName ) => {
             router.push({name: routeName })
        }

        const addOns =  computed(  () =>{
            if( plans.value ){
                // const plan = plans.value.find( ({subscriptionType}) => { return subscriptionType == 'Team' || subscriptionType == 'Team Anual'  })
                return  companionsData.value ? { ...companionsData.value  } : {}
            } else {
                router.push({ name : 'Home'})
            }
        })

        const onChange = ( type ) => {
            const max = addOns.value.maxQuantity - companionsData.value.currentQuantity +1

            
                if( type == 'add' ){
                    addOnCount.value = addOnCount.value < max ? ++addOnCount.value : max 
                } else if ( type == 'sub' ) {                    
                 
                    if( addOnCount.value <= max ){
                        addOnCount.value = --addOnCount.value 
                    }
                    if( addOnCount.value < 1 ){
                        addOnCount.value = 0
                    }
                }

                // addOnPrice.value = subscription.value.subscription.currentAmount.paymentTerm == 'Annual' ? (addOnCount.value * addOns.value.netAmount).toFixed(2) * 10 : (addOnCount.value * addOns.value.netAmount).toFixed(2)
                addOnPrice.value = (addOnCount.value * addOns.value.netAmount).toFixed(2);

            const t = parseFloat(selected.value.totalAmount) + parseFloat(addOnPrice.value)
            
            total.value.totalAmount =  (t).toFixed(2)
        }
        const onChangePlan = async ( ) => {
            let params =  { subscriptionId : subscription.value.subscription.id , companionsQuantity : addOnCount.value +  addOns.value.currentQuantity , }
            await store.dispatch('onModiyCompanions',params )
            await store.dispatch('getSubscription', { plan: 'vfn'})
        
            if( isSuccess.value ){
               
                await checkSubscription()
                dataLayerAddCompanions(  {paymentTerm:subscription.value.subscription.paymentTerm , before: companionsData.value.currentQuantity, after: addOnCount.value + 1 } )
                dataLayerViewChangeNotification( { type : 'success', paymentTerm : subscription.value.subscription.paymentTerm })

            }
            if( isError.value ){
                dataLayerAddCompanions( {paymentTerm: subscription.value.subscription.paymentTerm  , before: companionsData.value.currentQuantity , after: addOnCount.value + 1 })
                dataLayerViewChangeNotification( { type : 'unsuccessful', paymentTerm : subscription.value.subscription.paymentTerm })

            }
            
        }

        const getPlans = async () => {
            const currencyParameter = ( currency.value == 'MXN' ? `?currency=${currency.value}` : `?currency=${currency.value}`)
            await store.dispatch('getPlans', { currency: currencyParameter, useAuthToken : false }) 
            addOnCount.value = 0
            addOnPrice.value = (addOnCount.value * addOns.value.netAmount).toFixed(2)

        }

        const expireMemberDate = computed(() => {
            if( subscription.value ){
                let expire = new Date(subscription.value.subscription.creationDate )
                let yearFromDate = expire.getFullYear();
                let monthFromYear = expire.getMonth();
                let dayFromYear = expire.getDate();
                let newDate = new Date(yearFromDate, monthFromYear  + 3, dayFromYear);
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                let newExpre = newDate.toLocaleDateString('es-ES', options)

                return newExpre
             }
        })

         const checkSubscription = async () =>{
            if( !subscription.value ){
                await store.dispatch('getSubscription', { plan: 'vfn'})
                await store.dispatch('callCompanionsAvailable', { subscriptionId : subscription.value.subscription.id })
                if( !companionsData.value ){
                    router.push({ name : 'DashboardSubscription'})
                }
            } else {
                await store.dispatch('callCompanionsAvailable', { subscriptionId : subscription.value.subscription.id })

                if( !companionsData.value ){
                    router.push({ name : 'DashboardSubscription'})
                }
            }
        }
        
        /*
        * Mounted Functions
        */
        onMounted( async () => {
            await checkSubscription()
            await getPlans()    
          

        })

        return {
            dashboardTranslate,
            addOns,
            onBack,
            language,
            currency,
            subscription,
            addOnCount,
            addOnPrice,
            total,
            checkoutTranslate,
            notificationTranslate,
            isError,
            errorMessage,
            onChangePlan,
            onChange,
            loading,
            success,
            isSuccess,
            companionsData,
            companionsDataType,
            expireMemberDate
        }
    }
})
</script>

<style scoped>
.section-header {
	@apply text-3xl text-green-400 font-semibold md:font-bold;
}
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h5 {
    @apply md:text-sm text-green-400;
    font-size: 0.75rem;
}
button.disabled {
    @apply cursor-not-allowed bg-gray-400
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}
</style>